import { render } from "./message-row.vue?vue&type=template&id=25a6280c&scoped=true&ts=true"
import script from "./message-row.vue?vue&type=script&lang=ts"
export * from "./message-row.vue?vue&type=script&lang=ts"

import "./message-row.vue?vue&type=style&index=0&id=25a6280c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a6280c"]])

export default __exports__